// externals
import type { FC } from 'react';

// libraries
import { TextInput } from '@makemydeal/dr-shared-components/text-input';

// interfaces/types
import type { ColumnMapping, InputChangeInterstateEventHandler } from '../manualAccessoriesTypes';

//selectors
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// consts/enums
import * as deskingConstants from '../../../constants';

export type ManualAccessoryIdFieldStateProps = {
    disabled: boolean;
    index: number;
    code: string;
    idColumnMapping: ColumnMapping<string>;
    hasError?: boolean;
    errorMessage?: string;
};

export type ManualAccessoryIdFieldDispatchProps = {
    handleInputChange: InputChangeInterstateEventHandler;
    handleOnBlur: (fieldName: string) => void;
    handleKeyPress: (
        event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement>,
        fieldName: string
    ) => void;
};

export type ManualAccessoryIdFieldProps = ManualAccessoryIdFieldDispatchProps & ManualAccessoryIdFieldStateProps;

export const ACCESSORY_ID_MAX_LENGTH = 128;

export const ManualAccessoryIdField: FC<ManualAccessoryIdFieldProps> = ({
    disabled,
    index,
    code,
    idColumnMapping: { fieldName },
    handleInputChange,
    handleOnBlur,
    handleKeyPress
}) => {
    return (
        <TextInput
            size="sm"
            displayLabel={true}
            data-testid={`${fieldName}-${index}`}
            label={deskingConstants.ID}
            className="base-accessories-label"
            name={`${fieldName}-${index}`}
            onChange={(e) => {
                handleInputChange(e, fieldName);
            }}
            onBlur={() => {
                handleOnBlur(fieldName);
            }}
            onKeyDown={(e) => {
                handleKeyPress(e, fieldName);
            }}
            value={code}
            disabled={disabled}
            selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
        />
    );
};
